module.exports = __webpack_public_path__ + "static/media/BG_35.f1ec1596.png";